import { generateId } from '@ionic/react';
import { APP_LINKS } from 'features/radio/constants';

export default function GooglePlayBtn({ className }: { className?: string }) {
    const ids = [generateId(), generateId(), generateId(), generateId(), generateId(), generateId()];

    return (
        <a
            className={`${className || ''}`}
            href={APP_LINKS.google}
        >
            <svg
                width="135"
                height="46"
                viewBox="0 0 135 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.5"
                    y="1.25"
                    width="134"
                    height="44"
                    rx="4.5"
                    fill="black"
                />
                <path
                    d="M68.136 24.6356C65.784 24.6356 63.867 26.4246 63.867 28.8886C63.867 31.3376 65.784 33.1416 68.136 33.1416C70.489 33.1416 72.406 31.3376 72.406 28.8886C72.405 26.4246 70.488 24.6356 68.136 24.6356ZM68.136 31.4676C66.847 31.4676 65.736 30.4046 65.736 28.8896C65.736 27.3586 66.848 26.3116 68.136 26.3116C69.425 26.3116 70.536 27.3586 70.536 28.8896C70.536 30.4036 69.425 31.4676 68.136 31.4676ZM58.822 24.6356C56.47 24.6356 54.553 26.4246 54.553 28.8886C54.553 31.3376 56.47 33.1416 58.822 33.1416C61.175 33.1416 63.092 31.3376 63.092 28.8886C63.092 26.4246 61.175 24.6356 58.822 24.6356ZM58.822 31.4676C57.533 31.4676 56.422 30.4046 56.422 28.8896C56.422 27.3586 57.534 26.3116 58.822 26.3116C60.111 26.3116 61.222 27.3586 61.222 28.8896C61.223 30.4036 60.111 31.4676 58.822 31.4676ZM47.744 25.9416V27.7456H52.062C51.933 28.7606 51.595 29.5016 51.079 30.0166C50.451 30.6446 49.468 31.3376 47.744 31.3376C45.086 31.3376 43.008 29.1946 43.008 26.5366C43.008 23.8786 45.086 21.7356 47.744 21.7356C49.178 21.7356 50.225 22.2996 50.998 23.0246L52.271 21.7516C51.191 20.7206 49.758 19.9316 47.744 19.9316C44.103 19.9316 41.042 22.8956 41.042 26.5366C41.042 30.1776 44.103 33.1416 47.744 33.1416C49.709 33.1416 51.192 32.4966 52.351 31.2886C53.543 30.0966 53.914 28.4206 53.914 27.0676C53.914 26.6496 53.882 26.2626 53.817 25.9406H47.744V25.9416ZM93.052 27.3426C92.698 26.3926 91.618 24.6356 89.411 24.6356C87.22 24.6356 85.399 26.3596 85.399 28.8886C85.399 31.2726 87.204 33.1416 89.62 33.1416C91.569 33.1416 92.697 31.9496 93.165 31.2566L91.715 30.2896C91.232 30.9986 90.571 31.4656 89.62 31.4656C88.67 31.4656 87.993 31.0306 87.558 30.1766L93.245 27.8246L93.052 27.3426ZM87.252 28.7606C87.204 27.1166 88.525 26.2796 89.476 26.2796C90.217 26.2796 90.845 26.6506 91.055 27.1816L87.252 28.7606ZM82.629 32.8846H84.497V20.3836H82.629V32.8846ZM79.567 25.5866H79.503C79.084 25.0866 78.278 24.6356 77.264 24.6356C75.137 24.6356 73.188 26.5046 73.188 28.9056C73.188 31.2896 75.137 33.1426 77.264 33.1426C78.279 33.1426 79.084 32.6916 79.503 32.1766H79.567V32.7886C79.567 34.4156 78.697 35.2856 77.296 35.2856C76.152 35.2856 75.443 34.4646 75.153 33.7716L73.526 34.4486C73.993 35.5756 75.233 36.9616 77.296 36.9616C79.487 36.9616 81.34 35.6726 81.34 32.5306V24.8946H79.568V25.5866H79.567ZM77.425 31.4676C76.136 31.4676 75.057 30.3876 75.057 28.9056C75.057 27.4066 76.136 26.3116 77.425 26.3116C78.697 26.3116 79.696 27.4066 79.696 28.9056C79.696 30.3876 78.697 31.4676 77.425 31.4676ZM101.806 20.3836H97.335V32.8846H99.2V28.1486H101.805C103.873 28.1486 105.907 26.6516 105.907 24.2666C105.907 21.8816 103.874 20.3836 101.806 20.3836ZM101.854 26.4086H99.2V22.1236H101.854C103.249 22.1236 104.041 23.2786 104.041 24.2666C104.041 25.2346 103.249 26.4086 101.854 26.4086ZM113.386 24.6136C112.035 24.6136 110.636 25.2086 110.057 26.5276L111.713 27.2186C112.067 26.5276 112.727 26.3016 113.418 26.3016C114.383 26.3016 115.364 26.8806 115.38 27.9096V28.0386C115.042 27.8456 114.318 27.5566 113.434 27.5566C111.649 27.5566 109.831 28.5376 109.831 30.3706C109.831 32.0436 111.295 33.1206 112.935 33.1206C114.189 33.1206 114.881 32.5576 115.315 31.8976H115.379V32.8626H117.181V28.0696C117.182 25.8516 115.524 24.6136 113.386 24.6136ZM113.16 31.4646C112.55 31.4646 111.697 31.1586 111.697 30.4026C111.697 29.4376 112.759 29.0676 113.676 29.0676C114.495 29.0676 114.882 29.2446 115.38 29.4856C115.235 30.6446 114.238 31.4646 113.16 31.4646ZM123.743 24.8866L121.604 30.3066H121.54L119.32 24.8866H117.31L120.639 32.4616L118.741 36.6756H120.687L125.818 24.8866H123.743ZM106.937 32.8846H108.802V20.3836H106.937V32.8846Z"
                    fill="white"
                />
                <path
                    d="M47.4176 13.128C47.4176 13.966 47.1696 14.633 46.6726 15.131C46.1086 15.723 45.3726 16.019 44.4686 16.019C43.6026 16.019 42.8656 15.719 42.2606 15.119C41.6546 14.518 41.3516 13.774 41.3516 12.886C41.3516 11.997 41.6546 11.253 42.2606 10.653C42.8656 10.052 43.6026 9.75195 44.4686 9.75195C44.8986 9.75195 45.3096 9.83595 45.6996 10.003C46.0906 10.171 46.4036 10.394 46.6376 10.673L46.1106 11.201C45.7136 10.726 45.1666 10.489 44.4676 10.489C43.8356 10.489 43.2896 10.711 42.8286 11.155C42.3676 11.599 42.1376 12.176 42.1376 12.885C42.1376 13.594 42.3676 14.171 42.8286 14.615C43.2896 15.059 43.8356 15.281 44.4676 15.281C45.1376 15.281 45.6966 15.058 46.1436 14.611C46.4336 14.32 46.6016 13.915 46.6466 13.396H44.4676V12.675H47.3746C47.4046 12.832 47.4176 12.983 47.4176 13.128Z"
                    fill="white"
                />
                <path
                    d="M52.0277 10.622H49.2957V12.524H51.7597V13.245H49.2957V15.147H52.0277V15.885H48.5247V9.88501H52.0277V10.622Z"
                    fill="white"
                />
                <path
                    d="M55.2785 15.885H54.5075V10.622H52.8315V9.88501H56.9545V10.622H55.2785V15.885Z"
                    fill="white"
                />
                <path
                    d="M59.9375 15.885V9.88501H60.7085V15.885H59.9375Z"
                    fill="white"
                />
                <path
                    d="M64.1277 15.885H63.3567V10.622H61.6807V9.88501H65.8037V10.622H64.1277V15.885Z"
                    fill="white"
                />
                <path
                    d="M73.6084 15.11C73.0184 15.716 72.2854 16.019 71.4084 16.019C70.5314 16.019 69.7984 15.716 69.2094 15.11C68.6194 14.504 68.3254 13.762 68.3254 12.885C68.3254 12.008 68.6194 11.266 69.2094 10.66C69.7984 10.054 70.5314 9.75 71.4084 9.75C72.2804 9.75 73.0124 10.055 73.6044 10.664C74.1964 11.273 74.4924 12.013 74.4924 12.885C74.4924 13.762 74.1974 14.504 73.6084 15.11ZM69.7784 14.607C70.2224 15.057 70.7654 15.281 71.4084 15.281C72.0514 15.281 72.5954 15.056 73.0384 14.607C73.4824 14.157 73.7054 13.583 73.7054 12.885C73.7054 12.187 73.4824 11.613 73.0384 11.163C72.5954 10.713 72.0514 10.489 71.4084 10.489C70.7654 10.489 70.2224 10.714 69.7784 11.163C69.3354 11.613 69.1124 12.187 69.1124 12.885C69.1124 13.583 69.3354 14.157 69.7784 14.607Z"
                    fill="white"
                />
                <path
                    d="M75.5745 15.885V9.88501H76.5125L79.4285 14.552H79.4615L79.4285 13.396V9.88501H80.1995V15.885H79.3945L76.3435 10.991H76.3105L76.3435 12.147V15.885H75.5745Z"
                    fill="white"
                />
                <path
                    d="M47.4176 13.128C47.4176 13.966 47.1696 14.633 46.6726 15.131C46.1086 15.723 45.3726 16.019 44.4686 16.019C43.6026 16.019 42.8656 15.719 42.2606 15.119C41.6546 14.518 41.3516 13.774 41.3516 12.886C41.3516 11.997 41.6546 11.253 42.2606 10.653C42.8656 10.052 43.6026 9.75195 44.4686 9.75195C44.8986 9.75195 45.3096 9.83595 45.6996 10.003C46.0906 10.171 46.4036 10.394 46.6376 10.673L46.1106 11.201C45.7136 10.726 45.1666 10.489 44.4676 10.489C43.8356 10.489 43.2896 10.711 42.8286 11.155C42.3676 11.599 42.1376 12.176 42.1376 12.885C42.1376 13.594 42.3676 14.171 42.8286 14.615C43.2896 15.059 43.8356 15.281 44.4676 15.281C45.1376 15.281 45.6966 15.058 46.1436 14.611C46.4336 14.32 46.6016 13.915 46.6466 13.396H44.4676V12.675H47.3746C47.4046 12.832 47.4176 12.983 47.4176 13.128Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M52.0277 10.622H49.2957V12.524H51.7597V13.245H49.2957V15.147H52.0277V15.885H48.5247V9.88501H52.0277V10.622Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M55.2785 15.885H54.5075V10.622H52.8315V9.88501H56.9545V10.622H55.2785V15.885Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M59.9375 15.885V9.88501H60.7085V15.885H59.9375Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M64.1277 15.885H63.3567V10.622H61.6807V9.88501H65.8037V10.622H64.1277V15.885Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M73.6084 15.11C73.0184 15.716 72.2854 16.019 71.4084 16.019C70.5314 16.019 69.7984 15.716 69.2094 15.11C68.6194 14.504 68.3254 13.762 68.3254 12.885C68.3254 12.008 68.6194 11.266 69.2094 10.66C69.7984 10.054 70.5314 9.75 71.4084 9.75C72.2804 9.75 73.0124 10.055 73.6044 10.664C74.1964 11.273 74.4924 12.013 74.4924 12.885C74.4924 13.762 74.1974 14.504 73.6084 15.11ZM69.7784 14.607C70.2224 15.057 70.7654 15.281 71.4084 15.281C72.0514 15.281 72.5954 15.056 73.0384 14.607C73.4824 14.157 73.7054 13.583 73.7054 12.885C73.7054 12.187 73.4824 11.613 73.0384 11.163C72.5954 10.713 72.0514 10.489 71.4084 10.489C70.7654 10.489 70.2224 10.714 69.7784 11.163C69.3354 11.613 69.1124 12.187 69.1124 12.885C69.1124 13.583 69.3354 14.157 69.7784 14.607Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M75.5745 15.885V9.88501H76.5125L79.4285 14.552H79.4615L79.4285 13.396V9.88501H80.1995V15.885H79.3945L76.3435 10.991H76.3105L76.3435 12.147V15.885H75.5745Z"
                    stroke="white"
                    strokeWidth="0.2"
                    strokeMiterlimit="10"
                />
                <g filter={`url(#${ids[0]})`}>
                    <path
                        d="M10.4357 10.4226C10.1447 10.7306 9.97266 11.2086 9.97266 11.8276V33.9436C9.97266 34.5636 10.1447 35.0406 10.4357 35.3486L10.5097 35.4206L22.8987 23.0316V22.8856V22.7396L10.5097 10.3496L10.4357 10.4226Z"
                        fill={`url(#${ids[2]})`}
                    />
                    <path
                        d="M27.0274 27.1624L22.8984 23.0314V22.8854V22.7394L27.0284 18.6094L27.1214 18.6624L32.0144 21.4424C33.4114 22.2364 33.4114 23.5354 32.0144 24.3304L27.1214 27.1104L27.0274 27.1624Z"
                        fill={`url(#${ids[3]})`}
                    />
                    <g filter={`url(#${ids[1]})`}>
                        <path
                            d="M27.1215 27.1088L22.8975 22.8848L10.4355 35.3478C10.8955 35.8358 11.6565 35.8958 12.5135 35.4098L27.1215 27.1088Z"
                            fill={`url(#${ids[5]})`}
                        />
                    </g>
                    <path
                        d="M27.1215 18.6615L12.5135 10.3615C11.6565 9.87447 10.8955 9.93547 10.4355 10.4235L22.8985 22.8865L27.1215 18.6615Z"
                        fill={`url(#${ids[4]})`}
                    />
                </g>
                <rect
                    x="0.5"
                    y="1.25"
                    width="134"
                    height="44"
                    rx="4.5"
                    stroke="#A6A6A6"
                />
                <defs>
                    <filter
                        id={ids[0]}
                        x="9.97266"
                        y="10.0254"
                        width="23.0898"
                        height="25.7197"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="-0.15" />
                        <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                        />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_10302_6191"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="0.15" />
                        <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                        />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="effect1_innerShadow_10302_6191"
                            result="effect2_innerShadow_10302_6191"
                        />
                    </filter>
                    <filter
                        id={ids[1]}
                        x="10.4355"
                        y="22.8848"
                        width="16.6855"
                        height="12.8604"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="-0.15" />
                        <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                        />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_10302_6191"
                        />
                    </filter>
                    <linearGradient
                        id={ids[2]}
                        x1="21.8005"
                        y1="11.5936"
                        x2="5.01846"
                        y2="28.3756"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#00A0FF" />
                        <stop
                            offset="0.0066"
                            stopColor="#00A1FF"
                        />
                        <stop
                            offset="0.2601"
                            stopColor="#00BEFF"
                        />
                        <stop
                            offset="0.5122"
                            stopColor="#00D2FF"
                        />
                        <stop
                            offset="0.7604"
                            stopColor="#00DFFF"
                        />
                        <stop
                            offset="1"
                            stopColor="#00E3FF"
                        />
                    </linearGradient>
                    <linearGradient
                        id={ids[3]}
                        x1="33.8329"
                        y1="22.8854"
                        x2="9.63704"
                        y2="22.8854"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFE000" />
                        <stop
                            offset="0.4087"
                            stopColor="#FFBD00"
                        />
                        <stop
                            offset="0.7754"
                            stopColor="#FFA500"
                        />
                        <stop
                            offset="1"
                            stopColor="#FF9C00"
                        />
                    </linearGradient>
                    <linearGradient
                        id={ids[5]}
                        x1="24.8276"
                        y1="25.1787"
                        x2="2.06915"
                        y2="47.9372"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF3A44" />
                        <stop
                            offset="1"
                            stopColor="#C31162"
                        />
                    </linearGradient>
                    <linearGradient
                        id={ids[4]}
                        x1="7.29695"
                        y1="3.06127"
                        x2="17.4592"
                        y2="13.2236"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32A071" />
                        <stop
                            offset="0.0685"
                            stopColor="#2DA771"
                        />
                        <stop
                            offset="0.4762"
                            stopColor="#15CF74"
                        />
                        <stop
                            offset="0.8009"
                            stopColor="#06E775"
                        />
                        <stop
                            offset="1"
                            stopColor="#00F076"
                        />
                    </linearGradient>
                </defs>
            </svg>
        </a>
    );
}
